import Typography from '@portalterreno/react-ui-core/Typography';
import React from 'react';

import StyledSubtitle from './StyledSubtitle';
import StyledTypography from './StyledTypography';
import StyledWrapper from './StyledWrapper';

export type HeaderProps = React.HTMLAttributes<HTMLDivElement> & {
  firstLineTitle: string;
  secondLineTitle?: string;
  subtitle?: string;
};

const Header: React.FC<HeaderProps> = ({
  firstLineTitle,
  secondLineTitle,
  subtitle,
  ...rest
}) => {
  return (
    <StyledWrapper {...rest}>
      <StyledTypography
        variant='title'
        weight='regular'
      >
        {firstLineTitle}
      </StyledTypography>
      {secondLineTitle && (
        <Typography variant='title'>{secondLineTitle}</Typography>
      )}
      {subtitle && (
        <StyledSubtitle
          variant='body1'
          color='blackCoral'
          weight='light'
        >
          {subtitle}
        </StyledSubtitle>
      )}
    </StyledWrapper>
  );
};

export default React.memo(Header);
